import ApiCall from 'services/ApiCall'

const taxService = ApiCall._generateCrud('account.tax')

export default taxService
